<template>
  <div class="row">
    <div
      v-for="(card, index) in cards"
      :key="index"
      class="col-lg-4 col-md-6 col-sm-12 mb-4" 
    >
      <div class="card__bodyup">
        <div class="card__container">
          <div class="card__content">
            <div class="card__front" :class="card.backgroundClass">
              <h3 class="card__title">{{ card.title }}</h3>
            </div>
            <div class="card__back">
              <div class="card__body">
                <template v-for="(point, i) in card.points" :key="i">
                  <p class="my-0">{{ point }}</p>
                  <hr v-if="i < card.points.length - 1" />
                </template>
                <div class="text-end mt-2">
                  <a :href="card.link" class="dinamic-link">Read more</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const cards = [
  {
    title: 'Dedicated Lines',
    backgroundClass: 'card__front-background1',
    points: [
      'Global coverage across Tier 1, Tier2, Tier3 cities and far-flung areas.',
      'High Availability & Faster Delivery',
      'Committed Bandwidth up to 10G.',
      'Diverse, Scalable, Secure and Reliable Solutions.',
      'IPV6 Ready, Stringent SLA with 24*7*365 Proactive monitoring.'
    ],
    link: '/services/dedicated-lines'
  },
  {
    title: 'Business Broadband',
    backgroundClass: 'card__front-background2',
    points: [
      'Worldwide delivery capability in the segment.',
      'Fastest delivery with tailored options.',
      'High bandwidth offering.',
      'Convergent, Redundant Gateway, Hyper fast and fully flexible broadband services.',
      'Best in class SLA with Proactive Network Health Monitoring.'
    ],
    link: '/services/business-broadband'
  },
  {
    title: 'Wireless Connect',
    backgroundClass: 'card__front-background3',
    points: [
      'Global Wireless connectivity using 3G/4G/5G options.',
      'Quick deployments with High-capacity Bandwidth.',
      'Secure, optimal performance wireless connectivity solutions.',
      'Low latency, High speed mobility.',
      'Services monitoring and 24*7 Customer support.'
    ],
    link: '/services/wireless-connect'
  },
]
</script>

<style scoped>
:root {
  --level-one: translateZ(3rem);
  --level-two: translateZ(6rem);
  --level-three: translateZ(9rem);
}

.card__bodyup {
  display: grid;
  place-items: center;
  margin: 10px; 
}

.card__container {
  width: 100%;
  height: 0;
  padding-top: 100%;  
  position: relative;
  transition: all 0.3s ease-in-out; 
}

.card__content {
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 2em;
  transition: transform 1.5s;
  transform-style: preserve-3d;
}

.card__container:hover .card__content {
  transform: rotateY(0.5turn);
}

.card__front,
.card__back {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 2em;
  backface-visibility: hidden;
  transform-style: preserve-3d;
  display: grid;
  align-content: center;
}

.card__front {
  background-size: cover;
  background-position: center;
  background-blend-mode: overlay;
  color: white;
  border-radius: 15px;
}

.card__back {
  transform: rotateY(0.5turn);
  color: white;
  background: #f3f3f3;
  border-radius: 15px;
}

.card__title {
  margin: -4rem;
  font-size: 38px;
  transform: var(--level-three);
}

.card__body {
  transform: var(--level-two);
  font-weight: 400;
  font-size: 1rem;
  color: #000;
}

.dinamic-link {
  color: #007bff;
  text-decoration: none;
  font-weight: 500;
}

.dinamic-link:hover {
  text-decoration: underline;
}

.card__front-background1 {
  background-image: url("../assets/images/3cGzLfl.jpg");
}

.card__front-background2 {
  background-image: url("../assets/images/oXKKAd9.jpg");
}

.card__front-background3 {
  background-image: url("../assets/images/nEmUr0i.jpg");
}

@media (max-width: 1200px) {
  .card__title {
    font-size: 2.3rem;
  }
}

@media (max-width: 768px) {
  .card__title {
    font-size: 1.8rem;
  }
}

@media (max-width: 576px) {
  .card__title {
    font-size: 1.5rem;
  }
}
</style>
